<template>
  <div class="ReviewResults">
      <TopNavBar navtitle="评审成绩"></TopNavBar>
         <div class="rrhead">
             <img src="../assets/logo_2.jpg" alt="">
             <h1>歌唱考级评审成绩</h1>
             <h4>Singing Examination Results</h4>
         </div>
         <div class="enrolllist">
                <h2>考生信息</h2>            
                <ul class="examinfo">
                  <h1>2020中国音协贵州考区冬季考级</h1>
                     <img class="papers" src="../assets/head1.jpg" alt />
                  <li>            
                    <label for="">姓名：</label>
                    <span>李悦</span>
                  </li>
                  <li>            
                    <label for="">编号：</label>
                    <span>19102552</span>
                  </li>
                  <li>            
                    <label for="">专业：</label>
                    <span class="warning">电子琴</span>
                  </li>
                  <li>            
                    <label for="">级别：</label>
                    <span class="warning">三级</span>
                  </li>
                </ul>                 
            <!-- 考评项目及综合评价 -->   
                <h2>考评项目及综合评价</h2>             
                <ul class="examinfo comprehensive">
                  <li>            
                    <label for="">音准节奏：</label>
                    <span>好</span>
                  </li>
                  <li>            
                    <label for="">情感表现：</label>
                    <span>较好</span>
                  </li>
                  <li>            
                    <label for="">发声吐字：</label>
                    <span>尚可</span>
                  </li>
                  <li>            
                    <label for="">仪态修养：</label>
                    <span>较差</span>
                  </li>
                  <li>            
                    <label for="">评审意见：</label>
                    <span>
                        声音控制很好，准确表达歌曲的情感
                    </span>
                  </li>
                  <li>            
                    <label for="">综审成绩：</label>
                    <van-tag type="success" size="large">合格</van-tag>
                  </li>
                  <li>            
                    <label for="">评审时间：</label>
                    <span>2020.08.27 15:54:01</span>
                  </li>
                </ul>
                <van-button color="linear-gradient(to right, #ff6034, #ee0a24)">
                    保存成绩到相册
                </van-button>
                <!--黔音在线-->
                <div class="qrcode">
                    <p>关注黔音在线，了解更多动态！</p>
                    <img src="../assets/qyzxqr.jpg" width="120vw" alt="">
                </div>
             <copyright />
        </div>
  </div>
</template>

<script>
import copyright from '@/components/copyright.vue'
export default {
 components: {
    copyright
  },
}
</script>

<style>
.rrhead{background: #fff;padding: 10px;}
.rrhead>img{margin: 10px auto;display: block;width: 80%;}
.rrhead h1{font-size: 6.2vw;font-weight: 500;}
.rrhead h4{color: #888;}
.enrolllist h2{text-align: left;margin: 30px 0 5px 5px;color: #333;font-weight: 500;}
.enrolllist .comprehensive li{padding: 10px;}
.enrolllist .comprehensive li label{font-weight: bold;}
.qrcode{margin: 15px 0 0;}
.qrcode p{font-size: 2.8vw;}
#app .ReviewResults .copyright p,#app .ReviewResults .copyright p a:link{color: #888;}
</style>